import { useCallback, useEffect } from 'react';
import { useBlocker } from 'react-router';

/**
 * Block navigation and/or reload based on `bypassCondition`
 * @param bypassCondition if this function returns `true`, unblock navigation or reload
 * @param confirmMessage confirmation message (only for `blocker`, no effects for `beforeUnload`)
 * @param use flags to use features
 */
export const useConfirmLeave = (
  bypassCondition: () => boolean,
  confirmMessage = 'Are you sure to leave this page?',
  use: { blocker: boolean; beforeUnload: boolean } = { blocker: true, beforeUnload: true },
) => {
  // useBlocker
  // returning `true` will block navigation
  const confirmLeave = useCallback(() => {
    if (!use.blocker || bypassCondition()) return false;
    return !window.confirm(confirmMessage);
  }, [bypassCondition, confirmMessage, use.blocker]);
  useBlocker(confirmLeave);

  // onbeforeunload
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (use.beforeUnload && !bypassCondition()) {
        event.preventDefault();
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [bypassCondition, use.beforeUnload]);
};
